import React, { useCallback } from 'react';
import clsx from 'clsx'

import { pageSteps } from './pageStepperData'
import { SessionStorage } from '../../../common/cookie-storage'
import { STORAGEKEYS } from '../../../common/keys'
import { AppLinks } from '../../../environment/app-links'
import Paragraph from '../../atoms/Paragraph/Paragraph'
import { APP_COLOR, APP_FONT_SIZE } from '../../atoms/AtomsGlobalProps'



import  './PageStepperStyles.scss'


/**
 * ATOM  wyświetlający "kropki" w Stepperze.
 * @returns 
 */
const PageStepperStepIcon = ({ stepNumberToDisplay}: { stepNumberToDisplay: number }) => (
   <span className='page-stepper-step-icon'>
      { stepNumberToDisplay}
   </span>
)


const PageStepper = () => {
   const sessionStorage = new SessionStorage()
   const currentStep = parseInt(sessionStorage.get(STORAGEKEYS.CURRENT_PAGE_STEP) || '0', 10) //Domyślnie 0 aby nie zaznaczać żadnego kroku jeśli nic nie ma w storage
   const currentPathName = window.location.pathname

   const totalSteps = pageSteps.length
   const completedSteps = Math.min(currentStep - 1, totalSteps - 1)
   const stepperProgress = totalSteps > 1 ? (completedSteps / (totalSteps - 1)) * 100 : 0


   const isStepActive = useCallback((stepApplicationStateNumber: number) => {
      return Boolean(stepApplicationStateNumber <= currentStep) //Mniejszy bądź równy - aby każdy poprzedni krok również był zaznaczony
   }, [currentStep])

   const stepperInaccessibleOnPages = [ // Tablica ze ścieżkami w których Stepper MA NIE BYĆ dostępny. Na reszcie ścieżek go wyświetlamy
      AppLinks.return, AppLinks.error,
      AppLinks.fail, AppLinks.houston, AppLinks.sessionEnd,
   ]

   if(stepperInaccessibleOnPages.includes(currentPathName)) {
      return <div style={{ height: 14 }} /> // Placeholder
   }


   return (
      <div className='page-stepper-outer-wrapper' style={{['--stepper-progress' as any]: `${stepperProgress}%` }}>
         {pageSteps.map((step) => (
            <>
               <div className={clsx('page-stepper-single-step-wrapper', isStepActive(step.applicationState) && 'step-active')}>
                  <PageStepperStepIcon stepNumberToDisplay={step.stepNumberToDisplay} />
                  <Paragraph
                     className='page-stepper-step-label' 
                     color={isStepActive(step.applicationState) ? APP_COLOR.PRIMARY : APP_COLOR.DISABLED} 
                     size={APP_FONT_SIZE.EXTRA_SMALL}
                     bold={step.applicationState === currentStep} // Pogrubiamy tylko aktualny krok, kroki wcześniejsze pozostają bez pogrubienia
                  >
                     {step.label}
                  </Paragraph>
               </div>
            </>
         ))}
      </div>
   )
}

export default PageStepper